import React from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/homeNova';
import EventosEncerrados from './pages/EventosEncerrados';
import EventDetails from './pages/EventDetailNovo';
import AdminDashboard from './pages/AdminDashboard';
import Login from './pages/Login';
import MinhasInscricoes from './pages/MinhasInscricoes';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import TermosUso from './pages/TermosUso';
import './index.css';

function MainContent() {
  const location = useLocation();
  const isAdmin = location.pathname === '/admin' && localStorage.getItem('adminAuth') === 'true';

  return (
    <main className={isAdmin ? "main-content-full" : "main-content"}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/encerrados" element={<EventosEncerrados />} />
        <Route path="/admin" element={
          localStorage.getItem('adminAuth') === 'true' ? <AdminDashboard /> : <Login />
        } />
        <Route path="/login" element={<Login />} />
        <Route path="/minhas-inscricoes" element={<MinhasInscricoes />} />
        <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
        <Route path="/termos-de-uso" element={<TermosUso />} />
        <Route path="/eventos/:slug" element={<EventDetails />} />
        <Route path="/sucesso" element={
          <div style={{ textAlign: 'center', padding: '4rem 0' }}>
            <h1 style={{ color: 'var(--success)' }}>Inscrição Confirmada!</h1>
            <p style={{ marginTop: '1rem', color: 'var(--text-secondary)' }}>Obrigado por se inscrever. Te esperamos no evento.</p>
            <Link to="/" className="btn btn-primary" style={{ marginTop: '2rem' }}>Voltar ao Início</Link>
          </div>
        } />
      </Routes>
    </main>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="app-container">
        <Navbar />
        <MainContent />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
